/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_ButtonInputs */



/**
* | output |
* | --- |
* | "Sync" |
*
* @param {Offline_Sync_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_button = /** @type {((inputs?: Offline_Sync_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synchroniser")
	if (locale === "de") return /** @type {LocalizedString} */ ("Synchronisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sincronizza")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Синхронизировать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronizar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("同步")
	if (locale === "ja") return /** @type {LocalizedString} */ ("同期")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सिंक करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sincronizar")
	return /** @type {LocalizedString} */ ("Sync")
});